
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHeadingHUpProposal as ObiHeadingHUpProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-heading-h-up-proposal.js';
 
 
 

 
 export const ObiHeadingHUpProposal = createComponent({
   react: React,
   tagName: 'obi-heading-h-up-proposal',
   elementClass: ObiHeadingHUpProposalElement,
   events: {
     
   }
  });
 
 